<script setup lang="ts">
import { ref, type Ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { myRequest } from '@/utils/fetch'
import OGHeader from '@/components/OGHeader.vue'
import PersonProfile from '@/components/PersonProfile.vue'
import type { PersonResponse } from '@/types/personProfile'
import { useAuthStore } from '@/stores/authStore'

const route = useRoute()
const router = useRouter()
const loading = ref(false)
const person: Ref<PersonResponse | null> = ref(null)
const ready = ref(false)

const authStore = useAuthStore()

const handleTryForFree = () => {
  router.push('/login')
}

const fetchData = async () => {
  loading.value = true
  const result = (await myRequest('GET', `/app/shared/${route.params.sharedProfileID}`)) as PersonResponse
  person.value = result
  ready.value = true
  loading.value = false
}

fetchData()
</script>

<template>
  <OGHeader
    :title="
      person?.firstName !== ''
        ? `${person?.firstName} ${person?.lastName}`
        : person?.enrichmentData?.firstName && person?.enrichmentData?.firstName !== ''
          ? person?.enrichmentData?.firstName + ' ' + person?.enrichmentData?.lastName
          : person?.enrichmentData?.fullName && person?.enrichmentData?.fullName !== ''
            ? person?.enrichmentData?.fullName
            : person?.email
    "
    :subtitle="authStore.isAuthenticated ? person?.email || '' : ''"
  >
    <template v-slot:actions>
      <q-btn v-if="!authStore.isAuthenticated" color="primary" label="Try for Free" @click="handleTryForFree">
        <q-tooltip>Sign up for a 7 days free trial</q-tooltip>
      </q-btn>
    </template>
  </OGHeader>
  <PersonProfile v-if="person" :person="person" :ready="ready" :show-generate="false" :show-all-sections="true" />
  <q-inner-loading :showing="loading">
    <q-spinner-gears size="50px" color="primary" />
  </q-inner-loading>
</template>
